// LanguagePicker — the explicit customer language selector.
//
// Top of the resolution chain (cross-repo brief §11.2): an explicit choice here
// is persisted to localStorage and wins over browser language on the next boot.
// Rendered in the site footer so it's reachable on every page, including the
// chromeless /login surface where the header nav is suppressed.
//
// Option labels are the language's own endonym (English / Español), each shown
// in its own language regardless of the active locale — the conventional,
// most-recognizable way to present a language switcher.

import { useTranslation } from 'react-i18next';

import { useLocale } from './LocaleContext.js';
import { isSupportedLocale } from './resolveLocale.js';

export function LanguagePicker(): JSX.Element {
  const { t } = useTranslation('common');
  const { locale, setLocale, supportedLocales } = useLocale();

  return (
    <label className="language-picker">
      <span className="language-picker__label">{t('language.label')}</span>
      <select
        className="language-picker__select"
        value={locale}
        onChange={(e) => {
          const next = e.target.value;
          if (isSupportedLocale(next)) setLocale(next);
        }}
      >
        {supportedLocales.map((code) => (
          <option key={code} value={code}>
            {t(`language.${code}`)}
          </option>
        ))}
      </select>
    </label>
  );
}
